/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useState, useEffect } from 'react';
import { Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import { Pie } from '@antv/g2plot';
import { useHistory } from 'react-router-dom';
import { Row, Col } from '~/components';
import { iconEnum } from '~/modules/Helper/iconEnum';
import {
  ValorDestaqueDiv,
  IconeDiv,
  StatisticSpan,
  ValorDescricaoSpan,
  IconeMedioDiv,
  IconeMedioImg,
  ValorDescricaoDestaqueMedioDiv,
  ValorDestaqueMedioDiv,
  ValorSecundarioMedioSpan,
  GraficoMedio,
  DescricaoGrafico,
  CardWrapper,
  DescricaoLinkExternoDiv,
  DescricaoLinkExternoDivMedio,
  StatisticSpanMedio,
  StyledCol,
} from '~/components/Grafico/style';

import {
  useWindowListener,
  tiposDevice,
} from '~/components/Grafico/windowListener.component';
import ExercicioSelect from '~/components/Grafico/ExercicioSelect.component';
import { TIPO_ACESSO } from '../../Helper/tipoAcesso';
import { ensureContrast, AA_TEXT_PRIMARY_ON_LIGHT, AA_SURFACE } from '~/modules/Helper/contrast.helper';

function StatisticCard({
  id,
  Tamanho,
  Titulo,
  IconePersonalizado,
  Icone,
  IconeCor,
  TipoAcesso,
  ValorDestaque,
  DescricaoValorDestaque,
  ExibirValorSecundario,
  ValorSecundario,
  DescricaoValorSecundario,
  ExibirGraficoPorcentagem,
  DescricaoLinkExterno,
  PorcentagemValorDestaque,
  PorcentagemValorSecundario,
  ValorLink,
  corFonte,
  showExercicioSelect,
}) {
  const windowListener = useWindowListener();

  const donutData = [
    {
      type: DescricaoValorDestaque,
      value: parseFloat(PorcentagemValorDestaque),
    },
    {
      type: DescricaoValorSecundario,
      value: parseFloat(PorcentagemValorSecundario),
    },
  ];

  const [donut, setDonut] = useState(null);
  const { zoomFonte } = useSelector(state => state.configuration);
  const iconeCorSegura = ensureContrast(
    IconeCor,
    '#ffffff',
    4.5,
    AA_TEXT_PRIMARY_ON_LIGHT
  );
  const corFonteSegura = corFonte || AA_TEXT_PRIMARY_ON_LIGHT;
  const [config] = useState({
    title: false,
    description: false,
    label: {
      visible: false,
    },
    legend: {
      visible: false,
      flipPage: false,
    },
    autoFit: true,
    radius: 0.8,
    statistic: {
      visible: true,
      title: {
        content: 'Total',
        style: {
          fontSize: 15,
          fill: AA_TEXT_PRIMARY_ON_LIGHT,
        },
      },
      content: {
        content: `${Math.round(parseFloat(PorcentagemValorDestaque))}%`,
        style: {
          fontSize: 18,
          fill: AA_TEXT_PRIMARY_ON_LIGHT,
        },
      },
      triggerOn: null,
      triggerOff: null,
    },
    colorField: 'type',
    angleField: 'value',
    color: ['#5AD8A6', '#D9D9D9'],
    innerRadius: 1.2,
  });

  const history = useHistory();

  useEffect(() => {
    if (
      windowListener &&
      windowListener.device === tiposDevice.mobile &&
      donut
    ) {
      setDonut(null);
    } else if (
      windowListener &&
      windowListener.device === tiposDevice.desktop &&
      !donut
    ) {
      const element = document.getElementById(id);
      if (element) {
        const donutRender = new Pie(element, { data: donutData, ...config });
        setDonut(donutRender);
        donutRender.render();
      }
    }
  }, [config, donut, donutData, id, windowListener, zoomFonte]);

  function hrefFunction(link) {
    if (TipoAcesso === TIPO_ACESSO.INTERNO) return history.push(link);

    window.open(link, '_blank');
  }

  function handleCardActivate(event) {
    if (
      event.type === 'click' ||
      event.key === 'Enter' ||
      event.key === ' ' ||
      event.keyCode === 13
    ) {
      if (event.type === 'keydown') event.preventDefault();
      hrefFunction(ValorLink);
    }
  }

  // Sem aria-label: nome = texto visível do link (WCAG 2.5.3 / AccessMonitor label_03).
  // aria-label montado à mão falhava quando o DOM tinha formatação/nós extras.
  const cardActionProps = {
    role: 'link',
    tabIndex: 0,
    onClick: handleCardActivate,
    onKeyDown: handleCardActivate,
  };

  const iconeAlt = Titulo ? `Ícone de ${Titulo}` : 'Ícone personalizado';

  return (
    <>
      {Tamanho === 1 ? (
        <Tooltip title="Clique para mais detalhes">
          <CardWrapper
            title={
              <span
                style={{ fontSize: `${18 + 2 * zoomFonte}px`, fontWeight: 500 }}
              >
                {Titulo}
              </span>
            }
            extra={showExercicioSelect && <ExercicioSelect id={id} />}
            hoverable
            size="small"
            style={{
              fontSize: '25px',
              backgroundColor: AA_SURFACE,
              maxHeight: '99.5%',
              cursor: 'default',
            }}
          >
            <div {...cardActionProps} style={{ cursor: 'pointer' }}>
              <Row>
                <Col
                  lg={8}
                  xs={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <IconeDiv>
                    {Icone &&
                      iconEnum
                        .find(x => x.name === Icone)
                        ?.value({ color: iconeCorSegura })}
                  </IconeDiv>
                  {!Icone && (
                    <IconeMedioImg
                      tamanho={Tamanho}
                      src={IconePersonalizado}
                      alt={iconeAlt}
                    />
                  )}
                </Col>
                <Col
                  lg={16}
                  xs={16}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  {TipoAcesso === TIPO_ACESSO.INTERNO ? (
                    <StatisticSpan>
                      <Row>
                        <Col lg={24}>
                          <ValorDescricaoSpan>
                            {DescricaoValorDestaque}
                          </ValorDescricaoSpan>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={24}>
                          <ValorDestaqueDiv>{ValorDestaque}</ValorDestaqueDiv>
                        </Col>
                      </Row>
                    </StatisticSpan>
                  ) : (
                    <DescricaoLinkExternoDiv>
                      {DescricaoLinkExterno}
                    </DescricaoLinkExternoDiv>
                  )}
                </Col>
              </Row>
            </div>
          </CardWrapper>
        </Tooltip>
      ) : (
        <Tooltip title="Clique para mais detalhes">
          <CardWrapper
            title={
              <span
                style={{ fontSize: `${18 + 2 * zoomFonte}px`, fontWeight: 500 }}
              >
                {Titulo}
              </span>
            }
            extra={showExercicioSelect && <ExercicioSelect id={id} />}
            hoverable
            size="small"
            style={{
              height: '100%',
              fontSize: '25px',
              backgroundColor: AA_SURFACE,
              cursor: 'default',
            }}
          >
            <div
              {...cardActionProps}
              style={{ cursor: 'pointer', height: '100%' }}
            >
              {windowListener &&
              windowListener.device === tiposDevice.mobile &&
              id ? (
                <>
                  <Row
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    <Col
                      lg={6}
                      xs={10}
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      <IconeMedioDiv tamanho={Tamanho}>
                        {Icone &&
                          iconEnum
                            .find(x => x.name === Icone)
                            ?.value({ color: iconeCorSegura })}
                      </IconeMedioDiv>
                      {!Icone && (
                        <IconeMedioImg
                          tamanho={Tamanho}
                          src={IconePersonalizado}
                          alt={iconeAlt}
                        />
                      )}
                    </Col>
                    <StyledCol lg={11} xs={14}>
                      {TipoAcesso === TIPO_ACESSO.INTERNO ? (
                        <StatisticSpanMedio>
                          <Row>
                            <Col lg={24}>
                              <ValorDescricaoDestaqueMedioDiv
                                corFonte={corFonteSegura}
                                tamanho={Tamanho}
                              >
                                {DescricaoValorDestaque}
                                <br />
                                <ValorDestaqueMedioDiv
                                  corFonte={corFonteSegura}
                                  tamanho={Tamanho}
                                >
                                  {ValorDestaque}
                                </ValorDestaqueMedioDiv>
                              </ValorDescricaoDestaqueMedioDiv>
                            </Col>
                          </Row>
                          {ExibirValorSecundario && (
                            <>
                              <Row>
                                <Col lg={24}>
                                  <ValorSecundarioMedioSpan tamanho={Tamanho}>
                                    {`${DescricaoValorSecundario}: `}
                                    <span>{`${ValorSecundario}`}</span>
                                  </ValorSecundarioMedioSpan>
                                </Col>
                              </Row>
                            </>
                          )}
                        </StatisticSpanMedio>
                      ) : (
                        <DescricaoLinkExternoDiv>
                          {DescricaoLinkExterno}
                        </DescricaoLinkExternoDiv>
                      )}
                    </StyledCol>
                  </Row>
                </>
              ) : (
                <Row
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                  }}
                >
                  <Col
                    lg={6}
                    xs={12}
                    style={{ display: 'flex', justifyContent: 'center' }}
                  >
                    <IconeMedioDiv tamanho={Tamanho}>
                      {Icone &&
                        iconEnum
                          .find(x => x.name === Icone)
                          ?.value({ color: iconeCorSegura })}
                    </IconeMedioDiv>
                    {!Icone && (
                      <IconeMedioImg
                        tamanho={Tamanho}
                        src={IconePersonalizado}
                        alt={iconeAlt}
                      />
                    )}
                  </Col>
                  <StyledCol lg={11} xs={14}>
                    {TipoAcesso === TIPO_ACESSO.INTERNO ? (
                      <StatisticSpanMedio>
                        <Row>
                          <Col lg={24}>
                            <ValorDescricaoDestaqueMedioDiv tamanho={Tamanho}>
                              {DescricaoValorDestaque}
                              <br />
                              <ValorDestaqueMedioDiv tamanho={Tamanho}>
                                {ValorDestaque}
                              </ValorDestaqueMedioDiv>
                            </ValorDescricaoDestaqueMedioDiv>
                          </Col>
                        </Row>
                        {ExibirValorSecundario && (
                          <>
                            <Row>
                              <Col lg={24}>
                                <ValorSecundarioMedioSpan tamanho={Tamanho}>
                                  {`${DescricaoValorSecundario} `}
                                  <span>{`${ValorSecundario}`}</span>
                                </ValorSecundarioMedioSpan>
                              </Col>
                            </Row>
                          </>
                        )}
                      </StatisticSpanMedio>
                    ) : (
                      <DescricaoLinkExternoDivMedio>
                        {DescricaoLinkExterno}
                      </DescricaoLinkExternoDivMedio>
                    )}
                  </StyledCol>
                  <StyledCol
                    lg={6}
                    xs={8}
                    style={{ display: 'flex', justifyContent: 'flex-end' }}
                  >
                    {ExibirGraficoPorcentagem && (
                      <div>
                      <div
                        role="img"
                        aria-label={
                          Titulo
                            ? `Gráfico percentual: ${Titulo}`
                            : 'Gráfico percentual do card'
                        }
                      >
                        <GraficoMedio id={id} tamanho={Tamanho} />
                      </div>
                        <DescricaoGrafico tamanho={Tamanho}>
                          {`Percentual de ${DescricaoValorDestaque} sobre ${DescricaoValorSecundario}`}
                        </DescricaoGrafico>
                      </div>
                    )}
                  </StyledCol>
                </Row>
              )}
            </div>
          </CardWrapper>
        </Tooltip>
      )}
    </>
  );
}

export default StatisticCard;
